import { useTranslation } from 'react-i18next'

import { GuiaRepsolHacemosCocinaLogo } from '@/shared/ui/GuiaRepsolHacemosCocinaLogo'

const COLLABORATION_LABEL_CLASS = 'm-0 text-[clamp(0.75rem,1.8vw,0.9375rem)] italic text-[#B8AFA3]'
const COLLABORATION_LOGO_CLASS = 'text-[clamp(0.9375rem,2.4vw,1.1875rem)] text-[#E8DFD2]'

/** Awards-style trust mark: visible label outside the group, decorative lockup inside. */
export function FoodCostHeroCollaboration() {
    const { t } = useTranslation()

    return (
        <>
            <p className={COLLABORATION_LABEL_CLASS}>
                {t('foodCost.hero.collaborationLabel', 'Herramienta colaboradora')}
            </p>
            <div
                role='group'
                className='flex items-center justify-center'
                aria-label={t('foodCost.hero.collaborationAriaLabel', 'Hacemos cocina de Guía Repsol')}
            >
                <GuiaRepsolHacemosCocinaLogo className={COLLABORATION_LOGO_CLASS} />
            </div>
        </>
    )
}
